const firebaseConfig = {
  apiKey: "AIzaSyCJkXjpeGo7S8lV6yzXBuB3dtCZoGL8qsM",
  authDomain: "hua-psych-survey-platform.firebaseapp.com",
  databaseURL: "https://hua-psych-survey-platform-default-rtdb.firebaseio.com",
  projectId: "hua-psych-survey-platform",
  storageBucket: "hua-psych-survey-platform.appspot.com",
  messagingSenderId: "1037048503570",
  appId: "1:1037048503570:web:e63696655365147ed3e7cb",
  measurementId: "G-76H5J85NHK"
};

export default firebaseConfig
